module.exports = __webpack_public_path__ + "static/media/organisation.b5acd26a.svg";